import { Icon } from './icon';

export const IconDark = () => (
  <Icon>
    <path d="M18.7312 17.6188C12.8951 17.6188 8.16398 12.8003 8.16398 6.8564C8.16398 5.10907 8.57283 3.459 9.29842 2C5.0622 3.40206 2 7.45561 2 12.2376C2 18.1815 6.73111 23 12.5672 23C16.6877 23 20.2573 20.5981 22 17.094C20.9707 17.4347 19.8721 17.6188 18.7312 17.6188Z" />
  </Icon>
);
